<template>
  <div class="pipe-edit-holder" ref="pipeEdit">
    <div class="pipe-edit-left">
      <OptionList />
    </div>
    <div class="pipe-edit-center">
      <div class="pipe-edit-header">
        <div class="modal-label">{{ ModeText }}</div>
        <div id="pe-add-btn" class="pipe-edit-add-btn" @click="handleAddPipe" v-if="PipeMode != 'add'">
          <div class="pipe-edit-add-desc">
            Create Pipe</div>
          <img class="pipe-edit-add-icon" src="../../assets/svg/SVG/add_btn.svg">
        </div>
      </div>
      <!-- <DataInputDropDown v-if="PipeMode === 'edit'" :items="getPipeData" @input="handleCurrentEditPipe" title="Pipes" /> -->
      <DataInput v-for="(d, index) in getPipeDataFields" :key="index" :data="d" val="d.value" />
      <RightPanelButtons v-if="PipeMode != 'default'" :cancel="handleCancel" :save-label="BtnLabel"
        :save="handleSave" />
      <div class="pipe-editor-default-box">
        <button v-if="PipeMode === 'default'" class="pipe-editor-default-done-btn"
          @click="handleDoneDefault">Done</button>
      </div>
    </div>
    <div v-if="IsModalPipeError" style="position: absolute; z-index: 9999999; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;
  align-items: center;">
      <ModalPipeError :errors="ModalPipeErrors" label="Pipe Error" />
    </div>
    <div class=" pipe-edit-right">
      <Selector v-for="(selector, index) in getPipeDataSelectors" key="index" :selector="selector" />
      <NumericField id="pe-num-nps" class="ped-num-inc" type="edit" :obj="getNPSData"
        :bgColor="'rgba(247, 247, 247, 1)'" />
      <NumericField class="ped-num-inc" type="edit" :obj="getInnerDiameterData" :bgColor="'rgba(247, 247, 247, 1)'" />
      <div class="ped-svg-cont">
        <PipeEditDiameterSvg class="ped-svg-holder" />
      </div>
      <div class="dia-label">ø NPS</div>
      <div class="dia-label dia-id">ø ID</div>
    </div>
  </div>
  <div v-if="IsModalPipeSuccess" class="modal-class">
    <ConfirmModal :obj="ModalPipeSuccessObj" />
  </div>
</template>

<script>
import DataInput from '@/components/pipe/DataInput';
import { usePipeStore } from '@/store/PipeStore';
import RightPanelButtons from '@/components/pipe/RightPanelButtons';
import Selector from '@/components/pipe/Selector';
import NumericField from '@/components/nelson/NumericField';
import { useModalStore } from '@/store/ModalStore';
import OptionList from '@/components/pipe/OptionList';
// import { useSegmentStore } from '@/store/SegmentStore';
import PipeEditDiameterSvg from '@/modal/pipeEdit/pipeEditDiameterSvg';
// import { useInputStore } from '@/store/InputStore';
import DataInputDropDown from './DataInputDropDown.vue';
import ModalPipeError from '@/modal/pipeEdit/ModalPipeError.vue';
import ConfirmModal from '@/modal/pipeEdit/ConfirmModal.vue';

export default {
  name: 'PipeEdit',
  components: {
    PipeEditDiameterSvg,
    OptionList,
    NumericField,
    RightPanelButtons,
    DataInput,
    Selector,
    DataInputDropDown,
    ModalPipeError,
    ConfirmModal
  },
  computed : {
    IsModalPipeSuccess () {
      return usePipeStore().modalPipeSuccess;
    },
    ModalPipeSuccessObj () {
      return {
        promptLabel: 'Pipe Submission',
        promptDescription: usePipeStore().modalPipeSuccessObj.desc + ' was successfully added',
        buttonCancel: undefined,
        buttonALabel: 'Okay',
        buttonBLabel: null,
        buttonAFunc: function () {
          usePipeStore().modalPipeSuccess = false;
        },
        buttonBFunc: null
      };
    },
    IsModalPipeError () {
      return usePipeStore().modalError;
    },
    ModalPipeErrors () {
      return usePipeStore().errorList;
    },
    ModeText () {
      switch (this.PipeMode) {
        case 'add':
          return 'CREATE PIPE';
        case 'edit':
          return 'EDIT PIPE';
        default:
          return 'SELECT PIPE';
      }
    },
    PipeMode: {
      get () {
        return usePipeStore().getPipeMode;
      },
      set (value) {
        usePipeStore().setPipeMode(value);
      }
    },
    getPipeData () {
      return usePipeStore().getPipes;
    },
    getPipeDataFields () {
      return usePipeStore().getPipeData('input');
    },
    getPipeDataSelectors () {
      return usePipeStore().getPipeData('selector');
    },
    getNPSData () {
      return usePipeStore().getPipeData('numeric').filter( (pipe) => pipe.value === 'nominal_dia_m')[0];
    },
    getInnerDiameterData () {
      return usePipeStore().getPipeData('numeric').filter( (pipe) => pipe.value === 'internal_dia_m')[0];
    },
    BtnLabel () {
      return usePipeStore().getAllowPipeEdit ? 'SAVE' : 'DONE';
    },

  },
  methods : {
    handleCancel () {
      const pipeStore = usePipeStore();
      if (this.PipeMode === 'add' || this.PipeMode === 'edit') {
        pipeStore.resetEditPipe();
        pipeStore.setPipeMode('default');
      } else {
        pipeStore.setPipeModalVisible(false);
        // pipeStore.resetEditPipe();
        useModalStore().hideModal();
      }
    },
    handleCurrentEditPipe (value) {
      usePipeStore().setEditedPipe(value);
    },
    handleDoneDefault () {
      this.handleCancel();
    },
    handleSave () {
      // edited a pipe
      const pipeStore = usePipeStore();
      if (pipeStore.getAllowPipeEdit) {
        if (this.PipeMode === 'edit') {
         pipeStore.updateEditPipe();
        } else if (this.PipeMode === 'add') {
          pipeStore.updateEditPipe();
        }
      } else {
      // no edit, only changing the pipe
        // NOTE: commented out since we are using a global pipe edit not per segment edit
        // useSegmentStore().changeSelectedPipeSegmentId(pipeStore.getEditedPipe.id);
        // created a pipe
        this.handleCancel();
        // useInputStore().sprinklerCalc();
      }
    },
    handleAddPipe () {
      this.PipeMode = 'add';
      usePipeStore().setAllowPipeEdit(true, 'add');
    }
  }
};
</script>

<style scoped>
.modal-class {
  position: absolute;
  z-index: 99999;
  top: 30vh;
  left: 40vw;
  width: auto;
  background-color: white;
  box-shadow: 5px 10px 8px #888888;
}
.pipe-edit-holder {
  width: 900px;
  height: 500px;
  background-color: whitesmoke;
  position:absolute;
  z-index: 100;
  display: flex;
}
.pipe-edit-left {
  flex: 1;
}
.pipe-edit-center {
  flex: 1.2;
  padding: 20px;
  display: flex;
  flex-direction: column;
}
.pipe-edit-right {
  padding: 65px 10px 10px;
  background-color: white;
  flex: 1;
}
.pipe-edit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.add-pipe {
  cursor: pointer;
}
.ped-svg-holder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 170px;
  position:absolute;
  bottom: 55px;
}
.dia-label {
  font-size: 80%;
  font-weight: bold;
  position: absolute;
  top:165px;
}
.dia-id {
  top: 215px;
}
.modal-label {
  font-weight: bold;
  font-size: 85%;
}
.ped-num-inc {
  position: relative;
  padding-left: 70px;
  z-index: 999;
}
.pipe-edit-add-btn{
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.modal-prompt-confirm-bg {
  position: absolute;
  z-index: 9999;
}
.ped-svg-cont{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pipe-edit-add-desc{
  background-color: #FFFFFF;
  width: 100%;
  font-weight: bold;
  font-size: 80%;
  padding: 1px 2px;
  margin-bottom: 5px;
  text-align: center;
}
.pipe-edit-add-icon {
  width: 20px;
  cursor: pointer;
}
.pipe-editor-default-box {
    margin-top: auto;
      padding-right: 20px;
      width: 100%;
      height: 70px;
      position: sticky;
      bottom: 0px;
      display: flex;
      background-color: whitesmoke;
      align-items: center;
      justify-content: flex-end;
      z-index: 100;
}
.pipe-editor-default-done-btn {
    cursor: pointer;
      background-color: var(--nelson-green);
      color: white;
      height: 35px;
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 0.8em;
      font-weight: 900;
      letter-spacing: 0.05em;
      border: none;
}
</style>